<template>
  <div class="utd-customer-support">
    <div class="customer-service-explanation">
      <h4 class="ds1-utd-weight-normal"> {{ $t('LOGIN.FOR_FURTHER_ASSISTANCE') }} </h4>
      <p v-if="isUccState">
        <span class="ds1-utd-weight-bold"> {{ $t('MYACCOUNT.CONTACT_EMAIL') }}: </span>
        <a href="mailto:DL-UTD-ChinaSupport@uptodate.com">
          DL-UTD-ChinaSupport@uptodate.com
        </a>
      </p>
    </div>
    <div class="sign-in-explanation">
      <div v-if="isUccState">
        <p>
          <span class="ds1-utd-weight-bold"> {{ $t('MYACCOUNT.PHONE') }}: </span>
          <a href="tel://400-886-7266"> 400-886-7266</a> ({{ $t('LOGIN.PHONE_AVAILABILITY_UCC') }})
        </p>
      </div>

      <div v-else>
        <p class="contact-support-paragraph">
          <a class="contact-support-anchor"
             href="https://www.wolterskluwer.com/en/solutions/uptodate/contact/support">
            Contact support
            <i class="wk-icon wkce-icon-question-circle" />
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'UtdCustomerSupport',
    emits: [ 'closed' ],
    computed: {
        ...mapGetters('app', [ 'isUccState' ])
    },
    methods: {
        open() {
            this.$refs.modalDialogRef.open();
        },
        close() {
            this.$emit('closed');
            this.$refs.modalDialogRef.close();
        }
    }
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.utd-customer-support {
  p {
    .ds1-mt-0();

    &.contact-support-paragraph {
      .ds1-mt-compact();
    }
  }
}
</style>
